import { SharedLlmBlockFormFields } from './Shared/SharedFormFields';

export function LlmBlockFormFields() {
  return <SharedLlmBlockFormFields fieldNamePrefix="config" />;
}
